import {
  BarChart3,
  Users,
  Zap,
  CreditCard,
  DollarSign,
} from "lucide-react";

export const COLORS = {
  sky: { bg: "rgba(14,165,233,0.15)", fg: "rgb(56,189,248)", bar: "rgb(14,165,233)" },
  emerald: { bg: "rgba(16,185,129,0.15)", fg: "rgb(52,211,153)", bar: "rgb(16,185,129)" },
  amber: { bg: "rgba(245,158,11,0.15)", fg: "rgb(251,191,36)", bar: "rgb(245,158,11)" },
  violet: { bg: "rgba(139,92,246,0.15)", fg: "rgb(167,139,250)", bar: "rgb(139,92,246)" },
  rose: { bg: "rgba(244,63,94,0.15)", fg: "rgb(251,113,133)", bar: "rgb(244,63,94)" },
};

export const BarChart = ({ data, dataKey, height = 120, color = "#8b5cf6" }) => {
  const max = Math.max(...data.map((d) => d[dataKey]), 1);
  return (
    <div className="flex items-end gap-[2px]" style={{ height }}>
      {data.map((d, i) => (
        <div
          key={i}
          className="flex-1 rounded-t transition-colors relative group"
          style={{ height: `${Math.max((d[dataKey] / max) * 100, 3)}%`, backgroundColor: `${color}99` }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = `${color}dd`)}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = `${color}99`)}
          title={`${d.date}: ${d[dataKey]}`}
        >
          <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-slate-800 text-white text-[10px] px-1.5 py-0.5 rounded opacity-0 group-hover:opacity-100 whitespace-nowrap pointer-events-none z-10">
            {d.date}: {d[dataKey]}
          </div>
        </div>
      ))}
    </div>
  );
};

export const ProgressBar = ({ pct, color = "sky" }) => (
  <div className="flex-1 h-2 bg-white/5 rounded-full overflow-hidden">
    <div
      className="h-full rounded-full"
      style={{ width: `${pct}%`, backgroundColor: COLORS[color]?.bar || COLORS.sky.bar }}
    />
  </div>
);

export const StatCard = ({ icon: Icon, label, value, sub, color = "sky" }) => {
  const c = COLORS[color] || COLORS.sky;
  return (
    <div className="bg-slate-900/70 rounded-xl border border-white/5 p-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: c.bg }}>
          <Icon className="w-5 h-5" style={{ color: c.fg }} />
        </div>
        <div>
          <p className="text-2xl font-bold text-white">{value}</p>
          <p className="text-xs text-slate-400">{label}</p>
        </div>
      </div>
      {sub && <p className="text-[11px] text-slate-500 mt-2">{sub}</p>}
    </div>
  );
};

export { BarChart3, Users, Zap, CreditCard, DollarSign };
